import { createContext, useContext } from "react";
import type { PolicyName } from "../commons/policies";

export interface PermissionsContextValue {
    /** Outcome per policy NAME; capabilities are resolved in usePermission. */
    readonly permissions: Partial<Record<PolicyName, boolean>>;
    readonly isLoading: boolean;
}

/**
 * Fail-closed default: outside the provider (or in tests with no wrapper) every
 * permission reads as denied and nothing is loading.
 */
export const PermissionsContext = createContext<PermissionsContextValue>({
    permissions: {},
    isLoading: false,
});

export const usePermissionsContext = (): PermissionsContextValue =>
    useContext(PermissionsContext);
